import { render, staticRenderFns } from "./ReqStats.vue?vue&type=template&id=ed0c05a4&scoped=true"
import script from "./ReqStats.vue?vue&type=script&lang=js"
export * from "./ReqStats.vue?vue&type=script&lang=js"
import style0 from "./ReqStats.vue?vue&type=style&index=0&id=ed0c05a4&prod&lang=css"
import style1 from "./ReqStats.vue?vue&type=style&index=1&id=ed0c05a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0c05a4",
  null
  
)

export default component.exports